const TOKEN_KEY = "authToken";
const USER_INFO_KEY = "userInfo";
const EXPIRATION_KEY = "expirationTime"; // Key for expiration timestamp

// Save token with expiration
export const saveToken = (token) => {
  const expirationTime = Date.now() + 5 * 60 * 60 * 1000; // 5 hours in milliseconds
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(EXPIRATION_KEY, expirationTime);
};

// Get token if not expired
export const getToken = () => {
  const expirationTime = localStorage.getItem(EXPIRATION_KEY);
  if (expirationTime && Date.now() > expirationTime) {
    removeToken(); // Remove expired token
    return null;
  }
  return localStorage.getItem(TOKEN_KEY);
};

// Remove token
export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EXPIRATION_KEY);
};

// Save user info with expiration
export const saveUserInfo = (userInfo) => {
  const expirationTime = Date.now() + 5 * 60 * 60 * 1000; // 5 hours in milliseconds
  localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo));
  localStorage.setItem(EXPIRATION_KEY, expirationTime);
};

// Get user info if not expired
export const getUserInfo = () => {
  const expirationTime = localStorage.getItem(EXPIRATION_KEY);
  if (expirationTime && Date.now() > expirationTime) {
    removeUserInfo(); // Remove expired user info
    return null;
  }
  const userInfo = localStorage.getItem(USER_INFO_KEY);
  return userInfo ? JSON.parse(userInfo) : null;
};

// Remove user info
export const removeUserInfo = () => {
  localStorage.removeItem(USER_INFO_KEY);
  localStorage.removeItem(EXPIRATION_KEY);
};